import LogoutBtn from 'modules/common/LogoutBtn';
import React from 'react';

import styles from './HeaderTV.module.scss';

const HeaderTV: React.FC = () => (
  <header className={styles.header_tv}>
    <div className="pr-0 d-flex justify-content-end">
      <LogoutBtn classNameLogout={styles.logout} classNameItem={styles.item} />
    </div>
  </header>
);

export default HeaderTV;
